export const BRAND = {
  name: "Cozy Keys Service",
  legal: "Cozy Keys Service LLC",
  phone: "866-269-9539",
  phoneVanity: "866-COZY-KEY",
  email: "admin@cozykeysservices.com",
  city: "Pittsburgh, PA",
  established: "2025",
};

export const QUOTE_URL = "https://app.myridesync.com/quote?uid=cozykeysservices";

export const SOCIALS = {
  facebook: "https://www.facebook.com/profile.php?id=61589226534660",
  instagram: "https://www.instagram.com/cozykeysservices/",
  tiktok: "https://www.tiktok.com/@cozykeysservices",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_premier-rides-4/artifacts/7e98wazj_FullLogo_NoBuffer%20%281%29.jpg",
  fleet: "https://customer-assets.emergentagent.com/job_08a7eda1-40b9-4196-a043-f273eb99b450/artifacts/ovpwxf7k_unnamed%20%283%29.jpg",
  prom: "https://customer-assets.emergentagent.com/job_08a7eda1-40b9-4196-a043-f273eb99b450/artifacts/9sr0tacc__O2A9404.jpg",
  champagne: "https://images.unsplash.com/photo-1643618829236-a23857519fb6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  airport: "https://images.unsplash.com/photo-1764304532648-a5e422917a72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  concert: "https://images.unsplash.com/photo-1709731191876-899e32264420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior: "https://images.unsplash.com/photo-1768024175212-98eb7cd5ca46?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
  { id: "airport", title: "Airport Transfer", price: 85, image: IMAGES.airport,
    blurb: "Punctual arrivals and discreet pickups for every Pittsburgh terminal. Flight tracking, meet-and-greet, and a chilled cabin always at the ready." },
  { id: "date_night", title: "Date Night", price: 150, image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "Set the mood. Dim the lights. We handle the choreography — from her doorstep to the restaurant, with chilled champagne and roses if you wish." },
  { id: "prom", title: "Prom Set-Up", price: 250, image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "An entrance worth remembering. Red carpet rollout, polished SUV, and curated playlist. Parents text in real time. Memories made for keeps." },
  { id: "concert", title: "Concerts & Venues", price: 120, image: IMAGES.concert,
    blurb: "Skip the parking decks. Arrive at the gate, leave when you wish. Late-night returns with a kept seat and a bottle of water waiting." },
  { id: "dropoff_pickup", title: "Drop-Off / Pick-Up", price: 75, image: "https://images.unsplash.com/photo-1493238792000-8113da705763?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "Around-town errands, dinner reservations, business meetings. Door-to-door discretion at chauffeur standard." },
  { id: "special_occasion", title: "Special Occasion", price: 350, image: "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "Weddings, anniversaries, milestone birthdays, proposals. Multi-stop service, full vehicle detail, red carpet, champagne — choreographed to your moment." },
];

export const ADDONS = [
  { id: "champagne", label: "Chilled Champagne", price: 50, hint: "Iced flutes, ribbon-tied bottle" },
  { id: "flowers", label: "Premium Flowers", price: 35, hint: "Hand-tied bouquet, your color choice" },
  { id: "chocolates", label: "Artisan Chocolates", price: 20, hint: "Locally crafted assortment" },
  { id: "balloons", label: "Balloon Arrangement", price: 25, hint: "Themed for the moment" },
  { id: "red_carpet", label: "Red Carpet Set-Up", price: 75, hint: "Full rollout for arrival photos" },
];

export const RENTALS = [
  {
    id: "suburban_2024",
    name: "Chevrolet Suburban",
    year: "2024",
    tagline: "Blacked-out, captain's chairs, room for the whole crew.",
    price_day: 175,
    image: IMAGES.fleet,
    specs: [
      { label: "Seats", value: "7 Passengers" },
      { label: "Drivetrain", value: "4WD" },
      { label: "Cargo", value: "Generous" },
      { label: "Best for", value: "Family trips, group travel, road trips" },
    ],
    features: ["Captain's chairs", "Premium audio", "Tinted windows", "Apple CarPlay", "Full-size cargo"],
  },
  {
    id: "bmw_5_2019",
    name: "BMW 5 Series",
    year: "2019",
    tagline: "Refined, executive, head-turning curves at every light.",
    price_day: 80,
    image: "/images/bmw-5-series.jpg",
    specs: [
      { label: "Seats", value: "5 Passengers" },
      { label: "Drivetrain", value: "All-Wheel Drive" },
      { label: "Cargo", value: "Sedan trunk" },
      { label: "Best for", value: "Business, dates, weekend escapes" },
    ],
    features: ["Heated leather seats", "Sunroof", "Premium audio", "Bluetooth & USB", "Sport mode", "All-wheel drive"],
  },
];

export const MUSIC_OPTIONS = [
  { id: "driver_choice", label: "Surprise me — driver's choice" },
  { id: "rnb_soul", label: "R&B / Soul" },
  { id: "jazz", label: "Jazz / Lounge" },
  { id: "hiphop", label: "Hip-Hop / Throwbacks" },
  { id: "classical", label: "Classical / Instrumental" },
  { id: "pop", label: "Top 40 / Pop" },
  { id: "silence", label: "Silence, please" },
  { id: "playlist", label: "I'll share a playlist" },
];
